//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import extraConfig from './extraConfig';

export default {
  props: {
    data: { type: Array, required: true },
  },

  data() {
    return {
      extraConfig,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
  },
};
